module.exports = __webpack_public_path__ + "img/certificate-4.88d36b83.jpg";